<app-full-page-loading *ngIf="error"></app-full-page-loading>
